module.exports = __webpack_public_path__ + "/login_ui/img/cd-af7f42f2a4a033ab6a114a947cb70217.svg";